import { Box, Button } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty, getLocalData,navigation3 } from '../../common/helper'
import { Item } from '../../common/snippets'
import { SplitButton } from '../../common/SplitButton'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../common/svg/refresh'
import { ReportHeading } from './common/ReportHeading'
import * as id from './reportId'
import * as lb from './reportLables'
import * as url from './oldReportsUrls'
import { getBranchTransferFilter } from '../../../store/reports/reports_action'
import { updateLoader, updateModal } from '../../../store/common/common_action'

import { PaymentTypesOptions, reportViewOpt, urls } from '../../common/constants'
import BranchTransfer from './BranchTransfer/BranchTransfer'
import { GetRequest } from '../../common/api'
import Alert from '../../common/alert'
import { branchTransferHeaderUpdatedColumn } from './BranchTransfer/BrnhTransfConstant'
import ManageColumns from '../../common/ManageColumnsUI'
import * as mdt from '../../common/modaltypes'
import { RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
import { divideInNIntegers } from '../../common/mathHelper'


const BranchTransferReport = (props) => {
  const {
    data: { common, reports },
    getBranchTransferFilter,
    updateLoader,
    updateModal
  } = props
  const companySetting = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySetting?.DefaultCurrencyID;
  const { loginData, roleRights, showModal, modalType,companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports || 0
  const  BranchTransferPortraitV2 = companySettings?.[0]?.BranchTransferPortrait || 0
  const { intCompanyID, intUserID, IsAdmin, intBranchID } = loginData
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const reportName = 'Branch Transfer Report'
  const [selCompany, setSelCompany] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selFromBranch, setSelFromBranch] = useState('')
  const [selToBranch, setSelToBranch] = useState('')
  const [selVehicle, setSelVehicle] = useState('')

  const [transferByBranchList, setTransferByBranchList] = useState([])
  const [transferToBranchList, setTransferToBranchList] = useState([])
  const [vehicleList, setVehicleList] = useState([])
  const [resetFlag, setResetFlag] = useState(false)
  const [selPaymentType, setSelPaymentType] = useState(PaymentTypesOptions[0])
  const [selReportView, setselReportView] = useState(reportViewOpt[1])
  const [tableData, setTableData] = useState([])
  const [filterData, setFilterData] = useState({
    CompanyName: '',
    FromDate: '',
    ToDate: '',
    fromBranchName: '',
    toBranchName: '',
    VehicleNo: '',
    payment: '',
    Report: '',
  });
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  const [showReport, setShowReport] = useState(false)
  const [branchTransferFilter, setBranchTransferFilter] = useState({})
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
const criteriaHeaders = [
  { field: 'fromDate', header: 'From Transfer Date', textAlign: 'left' },
  { field: 'toDate', header: 'To Transfer  Date', textAlign: 'left' },
  { field: 'selFromBranch', header: 'Transfer By Branch', textAlign: 'left' },
  { field: 'selToBranch', header: 'Transfer To Branch', textAlign: 'left' },
  { field: 'selVehicle', header: 'Vehicle Number', textAlign: 'left' },
  { field: 'selPaymentType', header: 'Payment Type', textAlign: 'left' },
  { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
]
 const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY')||'',
    toDate: toDate.format('DD-MM-YYYY')||'',
    selFromBranch: selFromBranch?.name||'',
    selToBranch: selToBranch?.name||'',
    selVehicle: selVehicle?.name || `Auto-Dispatch.`,
    selPaymentType: selPaymentType?.Name || '',
    selReportView: selReportView?.name || '',
    dataType: 'entry',
  }
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights  || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
      setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  const updatedCol=branchTransferHeaderUpdatedColumn(UseFormattedLRinReports,loginCountryId,UseToPayAsCOD)
  useEffect(() => {
    focusElemnt(id.fromDate)
    const updateColumnDetails = async () => {
      try {
        const localDetailedColumns = await getLocalData('updatedCol1')
        let filnalcol = localDetailedColumns || updatedCol
        if (intCompanyID === RAJESH_TRANSPORT) {
          const removeFields = [
            'Sender^^SenderMobileNo',
            'SenderEmailID',
            'SenderEmailID^^SenderGSTN',
            'RecName^^RecMobileNo',
            'ReceiverEmailID',
            'ReceiverEmailID^^ReceiverGSTN'
          ]
          filnalcol = filnalcol.filter(
            (item) => !removeFields.includes(item.field)
          )
        }
        if (BranchTransferPortraitV2 === 1) {
          filnalcol = filnalcol.filter((item) => item.isMandatory)
        }
        setManageColumn(filnalcol)
      } catch (error) {
        let fallbackCol = updatedCol
        if (intCompanyID === RAJESH_TRANSPORT) {
          const removeFields = [
            'Sender^^SenderMobileNo',
            'SenderEmailID',
            'SenderEmailID^^SenderGSTN',
            'RecName^^RecMobileNo',
            'ReceiverEmailID',
            'ReceiverEmailID^^ReceiverGSTN'
          ]
          fallbackCol = fallbackCol.filter(
            (item) => !removeFields.includes(item.field)
          )
        }

        setManageColumn(fallbackCol)
        console.error(error)
      }
    }
    updateColumnDetails()
  }, [])
  useEffect(() => {
    if (!isEmpty(branchTransferFilter)) {
      let TransferFromBranch = branchTransferFilter.BranchTransferFromBranch.map((el) => ({ id: el.FromBranchID, name: el.FromBranch }))
      if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0) {
        TransferFromBranch = TransferFromBranch.filter((el) => el.id == intBranchID)
      }
      setTransferByBranchList(TransferFromBranch)
      let defaultBranch = TransferFromBranch.filter((obj) => obj?.id === intBranchID)
      const TransferToBranch = branchTransferFilter.BranchTransferToBranch.map((el) => ({ id: el.ToBranchID, name: el.ToBranch, FromBranchID: el.FromBranchID }))
      setTransferToBranchList(TransferToBranch)
      const TransferVehicle = branchTransferFilter.BranchTransferVehicle.map((el) => ({ id: el.VehicleID, name: el.VehicleNo, FromBranchID: el.FromBranchID, ToBranchID: el.ToBranchID }))
      setVehicleList(TransferVehicle)
      if (defaultBranch.length) {
        setSelFromBranch(defaultBranch[0])
        if (TransferToBranch.length) {
          let defaultToBranch = TransferToBranch.filter((val) => val?.FromBranchID === defaultBranch[0]?.id)
          if (defaultToBranch.length) {
            setSelToBranch(defaultToBranch[0])
            if (TransferVehicle.length) {
              let defaultVehicle = TransferVehicle.filter((val) => val?.FromBranchID === defaultBranch[0]?.id && val?.ToBranchID === defaultToBranch[0]?.id)
              if (defaultVehicle.length) {
                setSelVehicle(defaultVehicle[0])
              }
            }
          }
        }
      } else {
        setSelFromBranch(TransferFromBranch[0])
        if (TransferToBranch.length) {
          let defaultToBranch = TransferToBranch.filter((val) => val?.FromBranchID === TransferFromBranch[0]?.id)
          if (defaultToBranch.length) {
            setSelToBranch(defaultToBranch[0])
            if (TransferVehicle.length) {
              let defaultVehicle = TransferVehicle.filter((val) => val?.FromBranchID === TransferFromBranch[0]?.id && val?.ToBranchID === defaultToBranch[0]?.id)
              if (defaultVehicle.length) {
                setSelVehicle(defaultVehicle[0])
              }
            }
          }
        }
      }
    } else {
      setSelVehicle('')
      setSelToBranch('')
      setSelFromBranch('')
      setTransferByBranchList([])
      setTransferToBranchList([])
      setVehicleList([])
      setResetFlag(!resetFlag)
    }
  }, [branchTransferFilter])
  const callFilterAPi = () => {
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
      setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
    } else {
      const obj = {
        DateFrom: fromDate.format('YYYY-MM-DD'),

        DateTo: toDate.format('YYYY-MM-DD'),
        intBranchID: 0,
        intCompanyID,
      }
      getBranchTransferFilter(obj).then((res) => {
        if (res?.status == 'Success') {
          if (res.Data[0].BranchTransferFromBranch.length) {
            setBranchTransferFilter(res.Data[0])
          } else {
            setBranchTransferFilter({})
            setShowAlert({ show: true, message: 'No Data Found On Selected Date Range', nextId: '' })
          }
        } else {
          setShowAlert({ show: true, message: res.ErrMessage, nextId: '' })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }
  const handleClick2 = () => {
    if (selFromBranch === '' || selFromBranch === ' ') {
      setShowAlert({ show: true, message: "Please select From Branch" })
    } else if (selToBranch === '' || selToBranch === ' ') {
      setShowAlert({ show: true, message: "Please select To Branch" })
    } else if (selVehicle === '' || selVehicle === ' ') {
      setShowAlert({ show: true, message: "Please select Vehicle No" })
    } else {
      let urlBase = url.branchTransfer
      const urlData = url.branchTransferParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDate = fromDate.format('YYYY-MM-DD')
      urlData.ToDate = toDate.format('YYYY-MM-DD')
      urlData.FromBranchID = selFromBranch?.id
      urlData.FromBranchName = selFromBranch?.name
      urlData.ToBranchID = selToBranch?.id
      urlData.ToBranchName = selToBranch?.name
      urlData.VehicleID = selVehicle?.id
      urlData.VehicleNo = selVehicle?.name || `Auto-Dispatch.`
      urlData.intAllowExportToExcel = 1
      urlBase = appendToUrl(urlBase, urlData)
      window.open(urlBase, '_blank')
    }
  }
  const generateReport = () => {
    setShowReport(false)
    setIsPdfLoading(false)
    if (selFromBranch === '' || selFromBranch === ' ') {
      setShowAlert({ show: true, message: "Please select From Branch" })
    } else if (selToBranch === '' || selToBranch === ' ') {
      setShowAlert({ show: true, message: "Please select To Branch" })
    } else if (selVehicle === '' || selVehicle === ' ') {
      setShowAlert({ show: true, message: "Please select Vehicle No" })
    } else {
      setFilterData({
        ...filterData,
        CompanyName: loginData.strCompanyName,
        FromDate: moment(new Date(fromDate)).format("DD-MMM-YYYY"),
        ToDate: moment(new Date(toDate)).format("DD-MMM-YYYY"),
        fromBranchName: selFromBranch?.name,
        toBranchName: selToBranch?.name,
        VehicleNo: selVehicle?.name,
        payment: selPaymentType?.Name,
        Report: selReportView?.name,
      })
      const body = {
        FromBranchID: selFromBranch?.id,
        ToBranchID: selToBranch?.id,
        CompanyID: intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        PaymentTypeIDs: selPaymentType?.id,
        VehicleNo: selVehicle?.name,
      }
      updateLoader(true)
      GetRequest(urls.getBranchTransferData, body).then((res) => {
        if (res.status == 'Success') {
          // setShowReport(true)
          const data = res?.Data?.Table?.map((val) => ({ ...val, PaymentType: UseToPayAsCOD === 1 && val.PaymentType === 'TOPAY' ? 'COD' : val.PaymentType === 'TOPAY(MANUAL)' ? 'COD(MANUAL)' : val.PaymentType }))
          let formattedData = formatData(data)
          let mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
            ...val,
            align: val.headerSx.textAlign,
            export: val.exportHead,
            weight:val.weight?? 80
          }))
            const reportPayload = {
                    reportName,
                    criteriaHeaders: criteriaHeaders,
                    criteriaData: [criteriaData],
                    tableData: formattedData,
                    mainHeader: mainHeader,
                    isShowManageColumn: true,
                    manageColumnID: 'updatedCol1',
                    serialNokey :'sno',
                    showColumnBorders: true,
                    totalSubKey:3,
                    colSpanMarker: 'ItemType'
                  }
           const rid = Date.now().toString()

            if (!window.generatedReports) {
              window.generatedReports = {}
            }

            window.generatedReports[rid] = reportPayload

            window.open(`/view-report?rid=${rid}`, "_blank")
          // setTableData(data)
        } else {
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        console.log('Error:', err)
      }).finally(() => {
        updateLoader(false)
      })
    }
  }
  //handle Close Alert
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  const handleFromBranch = (val) => {
    setSelFromBranch(val)
    let toBranchList = transferToBranchList?.filter((obj) => obj?.FromBranchID === val?.id);
    if (toBranchList.length) {
      setSelToBranch(toBranchList[0])
      let vehicleListFilter = vehicleList?.filter((obj) => obj.FromBranchID === val?.id && obj.ToBranchID === toBranchList[0]?.id)
      if (vehicleListFilter.length) {
        setSelVehicle(vehicleListFilter[0])
      } else {
        setSelVehicle(' ')
      }
    } else {
      setSelToBranch(' ')
      setSelVehicle(' ')
    }
  }
  const handleToBranch = (val) => {
    setSelToBranch(val)
    let vehicleListFilter = vehicleList?.filter((obj) => obj.FromBranchID === val?.FromBranchID && obj.ToBranchID === val?.id)
    if (vehicleListFilter.length) {
      setSelVehicle(vehicleListFilter[0])
    } else {
      setSelVehicle(' ')
    }
  }
  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem('updatedCol1', JSON.stringify(item))
  }
    const formatData = (data = []) => {
     let headers=manageColumn.filter((obj) => obj.isSelected)
          let detailsData = []
          let totalRow = {
              Units: 0,
              Freight: 0,
              CartageAmount: 0,
              HamaliCharge: 0,
              OtherCharges: 0,
              Valuation: 0,
              BookingGST: 0,
              NetAmount: 0
          }
          data.forEach((val) => {
              detailsData.push({
                  ...val,
                  isRowData: true,
                  'LRNO^^ManualLRNo': `${val.LRNO}\n${val.ManualLRNo}`,
                  'SourceCity^^SourceBranch': `${val.SourceCity}\n${val.SourceBranch}`,
                  'DestinationCity^^DestinationBranch': `${val.DestinationCity}\n${val.DestinationBranch}`,
                  'Sender^^SenderMobileNo': `${val.Sender}\n${val.SenderMobileNo}`,
                  'SenderGSTN^^SenderEmailID': loginCountryId === 2 ? `${val.SenderEmailID}` : `${val.SenderGSTN}\n${val.SenderEmailID}`,
                  'RecName^^RecMobileNo': `${val.RecName}\n${val.RecMobileNo}`,
                  'ReceiverGSTN^^ReceiverEmailID': loginCountryId === 2 ? `${val.ReceiverEmailID}` : `${val.ReceiverGSTN}\n${val.ReceiverEmailID}`,
                  TransferDateTime: moment(val.TransferDateTime).format("DD-MMM-YY"),
                  TransferTime: moment(val.TransferDateTime).format("HH:mm"),
                  dataType: 'entry'
              })
              totalRow.Units += +val.Units || 0
              totalRow.Freight += +val.Freight || 0
              totalRow.CartageAmount += +val.CartageAmount || 0
              totalRow.HamaliCharge += +val.HamaliCharge || 0
              totalRow.OtherCharges += +val.OtherCharges || 0
              totalRow.Valuation += +val.Valuation || 0
              totalRow.BookingGST += +val.BookingGST || 0
              totalRow.NetAmount += +val.NetAmount || 0
          })
  
          detailsData.sort(
              (a, b) =>
                  moment(`${a.TransferDateTime} ${a.TransferTime}`).valueOf() -
                  moment(`${b.TransferDateTime} ${b.TransferTime}`).valueOf()
          )
          detailsData = detailsData.map((val, i) => ({
              ...val,
              sno: i + 1
          }))
  
          // 🔹 Sub-heading rows
          const subHeadingRows = makeSubHeadingRows(headers, filterData)
  
          // 🔹 Total row colSpan dynamic
          const qtyIndex = headers.findIndex(h => h.field === "Units")
          const firstHeader = headers[0]?.field
          const totalDataRow = {
              ...totalRow,
              dataType: 'total',
              [firstHeader]: `Total: Transfer From Branch ${filterData.fromBranchName}`,
              colSpan: { [firstHeader]: qtyIndex > 0 ? qtyIndex : 1 },
              align: { [firstHeader]: 'right' }
          }
  
          return [
              ...subHeadingRows,
              ...detailsData,
              totalDataRow
          ]
      }
        const makeSubHeadingRows = (headers) => {
        const { pickedHeaders, lengths } = getPickedHeaders(headers, 3)
        return [{
            dataType: 'subHeader',
            colSpan: Object.fromEntries(
                pickedHeaders.map((key, i) => [key, lengths[i]])
            ),
            align: {
                [pickedHeaders[0]]: 'left',
                [pickedHeaders[1]]: 'center',
                [pickedHeaders[2]]: 'right'
            },
            [pickedHeaders[0]]: `Report View: ${selReportView?.name}`,
            [pickedHeaders[1]]: `Transfer From Branch: ${selFromBranch?.name}`,
            [pickedHeaders[2]]: `Transfer To Branch: ${selToBranch?.name}`,
            totalSubKey:3,
        }]
    }
     const getPickedHeaders = (headers, parts = 3) => {
            const lengths = divideInNIntegers(headers.length, parts)
            let index = 0
            const pickedHeaders = []
    
            lengths.forEach(span => {
                pickedHeaders.push(headers[index]?.field)
                index += span
            })
            return { pickedHeaders, lengths }
        }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <ReportHeading reportName={reportName.slice(0, -7)} />
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompnay}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            onSelect={(val) => setSelCompany(val)}
            width="300px"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            name={'from_date'}
            label={`From Transfer Date`}
            value={fromDate}
            id={id.fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            name={'to_date'}
            label={'To Transfer  Date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt(id.goButtonDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            variant="contained"
            onKeyDown={(e) => {
              navigation3(e, id.selBranch, id.toDate, () => {
                callFilterAPi()
              })
            }}
            onClick={callFilterAPi}
            id={id.goButtonDate}
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={'Transfer By Branch'}
            id={id.selBranch}
            data={transferByBranchList || []}
            defaultvalue={selFromBranch?.name || ''}
            value={selFromBranch?.name || ''}
            disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==0}
            resetFlag={resetFlag}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) =>
              handleFromBranch(val)
            }
            width="100%"
            nextId={id.destinationBranch}
            prevId={id.goButtonDate}
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={'Transfer To Branch'}
            id={id.destinationBranch}
            data={transferToBranchList?.filter((obj) => obj?.FromBranchID === selFromBranch?.id) || []}
            defaultvalue={selToBranch?.name || selToBranch}
            value={selToBranch?.name || selToBranch}
            resetFlag={resetFlag}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) =>
              handleToBranch(val)
            }
            width="100%"
            nextId={id.vehicle}
            prevId={id.selBranch}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={lb.vehicle}
            id={id.vehicle}
            data={vehicleList?.filter((obj) => obj.FromBranchID === selFromBranch?.id && obj.ToBranchID === selToBranch?.id)}
            defaultvalue={selVehicle?.name || selVehicle}
            value={selVehicle?.name || selVehicle}
            resetFlag={resetFlag}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(vehicle) => setSelVehicle(vehicle)}
            width="100%"
            nextId={id.paymentType}
            prevId={id.destinationBranch}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={lb.paymentType}
            id={id.paymentType}
            data={PaymentTypesOptions}
            searchPlaceholder={`Search By Payment`}
            defaultvalue={selPaymentType?.Name}
            HasAllSelect={true}
            disabled={true}
            dataKey={`Name`}
            idKey={`id`}
            onSelect={setSelPaymentType}
            nextId={id.reportView}
            prevId={id.vehicle}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={lb.reportView}
            id={id.reportView}
            data={reportViewOpt}
            searchPlaceholder={`Search By Report`}
            defaultvalue={selReportView?.name}
            dataKey={`name`}
            disabled={true}
            idKey={`id`}
            onSelect={setselReportView}
            nextId={id.reportmainButton}
            prevId={id.paymentType}
          />
        </Item>
        <Item sx={sx.itemsx} onKeyDown={(e) => {
          navigation3(e, showReport ? isPdfLoading ? "backBtn" : disableExcel ? "exportPdf" : "exportExcelBtn" : id.fromDate, id.reportView, () => {
            generateReport()
          })
        }}>
          <SplitButton
            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            hideToggle={false}
            id1={id.reportmainButton}
            onClick1={generateReport}
            onClick2={handleClick2}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, cursor: 'pointer' }} onClick={() => {
          setFromDate(moment(new Date()))
          setToDate(moment(new Date()))
          setSelVehicle('')
          setSelToBranch('')
          setSelFromBranch('')
          setTransferByBranchList([])
          setTransferToBranchList([])
          setVehicleList([])
          setResetFlag(!resetFlag)
        }} >
          <RefreshSvg />
        </Item>
      </Box>
      {showModal && mdt.BrnhTransferMCol === modalType ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} /> : null}
      {/* {showReport && <BranchTransfer loginCountryId={loginCountryId} updateModal={updateModal} columnSummaryDefs={manageColumn.filter((obj) => obj.isSelected)} disableExcel={disableExcel} loginData={loginData} filterData={filterData} tableData={tableData} updateLoader={updateLoader} isPdfLoading={isPdfLoading} setIsPdfLoading={setIsPdfLoading} UseFormattedLRinReports={UseFormattedLRinReports}/>} */}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchTransferFilter, updateLoader, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(BranchTransferReport)
